import React from 'react'

import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'

const withMutation = WrappedComponent => {
  return props => {
    const {
      onMutationError, // via withFormResults
      onMutationCompleted, // via withFormResults
      setModal, // via withRedux
      setForm, // via withState
      setApproved, // via withState
      setDiscountAmount, // via withState
      refetchCart, // via withQuery (passed down from parent Cart)
      refetchPlans // via withQuery (passed down from parent Plans)
    } = props

    const handleCompleted = async (data) => {
      // Refetch query to get updated accountDiscount associations
      // Use whichever refetch function was passed (Cart or Plans context)
      const refetchFn = refetchCart || refetchPlans
      if (refetchFn) {
        await refetchFn()
      }

      // Always close modal after submission (success or error)
      setForm({
        locationId: '',
        familySize: '',
        adjustedGrossIncome: '',
        specialCircumstances: ''
      })
      setApproved(false)
      setDiscountAmount(null)
      setModal({ open: false })

      // Call withFormResults handler
      if (onMutationCompleted) {
        onMutationCompleted(data)
      }
    }

    const [
      applyForFinancialAid,
      { loading: mutationLoading, error: mutationError, data: mutationData }
    ] = useMutation(mutation, {
      onError: onMutationError,
      onCompleted: handleCompleted
    })

    return (
      <WrappedComponent
        mutationLoading={mutationLoading}
        mutationError={mutationError}
        mutationData={mutationData}
        applyForFinancialAid={applyForFinancialAid}
        {...props}
      />
    )
  }
}

export default withMutation
